import React from 'react';
import "../Figure.css"


function Figure9() {
  return (
    <div>
        <table class="equal-width-table">
          <thead>
            <tr>
            <th> </th>
              <th> Zn concentration after incubation (5min)</th>
              <th> Zn concentration after removal of the blank </th>
              <th> Zn uptake </th>
            </tr>
          </thead>
          <tbody>
          <tr>
              <th> Water </th>
              <td> 1.25 mg/L </td>
              <td> 1.04 mg/L </td>
              <td> 0 mg/L </td>
            </tr> 
            <tr>
              <th> EC20 </th>
              <td> 0.45 mg/L </td>
              <td> 0.16 mg/L </td>
              <td> 0.88 mg/L </td>
            </tr>
            <tr>
              <th> SpaC </th>
              <td> 0.75 mg/L </td>
              <td> 0.49 mg/L </td>
              <td> 0.55 mg/L </td>
            </tr>
            <tr>
              <th className="colored-cell" colSpan="3"> Uptake difference </th>
              <th className="colored-cell">0.33 mg/L</th>
            </tr>
          </tbody>
        </table>
    </div>
  );
}

export default Figure9;